/* tslint:disable */
/* eslint-disable */
/**
 * V2M Backend API
 * Backend API for the V2M multi-brand platform (word2mail, koe2mail, sprich2mail, ...) - handles authentication, quota management, and LLM requests
 *
 * The version of the OpenAPI document: 1.0.5
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { PaymentMethodsResponseFromJSON } from '../models/index';
import * as runtime from '../runtime';
/**
 *
 */
export class PaymentsApi extends runtime.BaseAPI {
    /**
     * Return the payment methods available in a market, with live provider health.  Public endpoint — no authentication required, no user-specific data returned. ``market`` defaults to ``DEFAULT_MARKET`` (today\'s only real value, since ``resolve_market`` is still a stub — plan §\"resolve_market NIE istnieje jeszcze\"); the frontend may pass an explicit market once real market resolution lands.  Args:     market: Market identifier (see ``market_routing.provider_chain_for``); an         unrecognized value falls back to ``DEFAULT_MARKET``\'s methods.  Returns:     The market\'s methods, each flagged ``available=False`` when that method\'s     provider currently has an OPEN circuit (per ``default_fallback_router``).
     * Get Payment Methods
     */
    async getPaymentMethodsV1PaymentsMethodsGetRaw(requestParameters, initOverrides) {
        const queryParameters = {};
        if (requestParameters['market'] != null) {
            queryParameters['market'] = requestParameters['market'];
        }
        const headerParameters = {};
        let urlPath = `/v1/payments/methods`;
        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => PaymentMethodsResponseFromJSON(jsonValue));
    }
    /**
     * Return the payment methods available in a market, with live provider health.  Public endpoint — no authentication required, no user-specific data returned. ``market`` defaults to ``DEFAULT_MARKET`` (today\'s only real value, since ``resolve_market`` is still a stub — plan §\"resolve_market NIE istnieje jeszcze\"); the frontend may pass an explicit market once real market resolution lands.  Args:     market: Market identifier (see ``market_routing.provider_chain_for``); an         unrecognized value falls back to ``DEFAULT_MARKET``\'s methods.  Returns:     The market\'s methods, each flagged ``available=False`` when that method\'s     provider currently has an OPEN circuit (per ``default_fallback_router``).
     * Get Payment Methods
     */
    async getPaymentMethodsV1PaymentsMethodsGet(requestParameters = {}, initOverrides) {
        const response = await this.getPaymentMethodsV1PaymentsMethodsGetRaw(requestParameters, initOverrides);
        return await response.value();
    }
}
